import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './styles/oddsBoostWidget.scss';

const BetCardHeader = ({ categoryName }) => {
    const [ t ] = useTranslation();

    return (
        <div className='odds-boost-widget__header'>
            <div>{categoryName}</div>
            <div className='odds-boost-widget__header__odds-boost'>
                <span className='odds-boost-widget__header__odds-boost-prices'>
                    {t('odds_boost.was')}
                </span>
                <span className='odds-boost-widget__header__odds-boost-prices'>
                    {t('odds_boost.now')}
                </span>
            </div>
        </div>
    );
};

BetCardHeader.propTypes = {
    categoryName: PropTypes.string.isRequired,
};

export default BetCardHeader;
